module.exports = __webpack_public_path__ + "static/media/AbuDhabi.0180afdc.jpg";